import { ClientOnly, createFileRoute } from "@tanstack/react-router"
import { Suspense } from "react"

import TrailsDemo from "./-components/TrailsDemo"

import "./-components/trails-embed.css"

export const Route = createFileRoute("/features/trails/demo")({
  head: () => ({
    links: [{ rel: "canonical", href: "https://entire.com/features/trails/demo" }],
    meta: [
      { title: "Interactive Trails demo · Entire" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: TrailsEmbed,
})

function TrailsEmbed() {
  // The embedding page keeps this frame hidden until the demo reports ready, so
  // nothing stands in for the product UI while it loads.
  return (
    <div data-trails-embed className="fixed inset-0 flex overflow-hidden bg-base">
      <ClientOnly>
        <Suspense>
          <TrailsDemo />
        </Suspense>
      </ClientOnly>
    </div>
  )
}
